import React from "react";

function StoryUnmute() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g
        id="Audio_On_Icon"
        data-name="Audio On Icon"
        transform="translate(-1107 -134)"
      >
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="18.5"
          cy="18.5"
          r="18.5"
          transform="translate(1107 134)"
          opacity="0.5"
        />
        <path
          id="Path_24831"
          data-name="Path 24831"
          d="M1.93,15.131H5.547l4.925,4.029a.465.465,0,0,0,.76-.36V4.02a.465.465,0,0,0-.76-.36L5.547,7.69H1.93A.93.93,0,0,0,1,8.62V14.2A.93.93,0,0,0,1.93,15.131ZM21.463,11.41a10.207,10.207,0,0,1-3.477,7.685l-1.319-1.319a8.372,8.372,0,0,0,0-12.732l1.319-1.319A10.207,10.207,0,0,1,21.463,11.41Zm-4.651,0a5.571,5.571,0,0,0-2.127-4.384L13.356,8.355a3.721,3.721,0,0,1,0,6.109l1.329,1.329A5.571,5.571,0,0,0,16.812,11.41Z"
          transform="translate(1114.268 141.09)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default StoryUnmute;
